import { Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const InstagramSection = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-pink-50 to-purple-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-section-title text-primary mb-4">
            Seguici su <span className="text-gold">Instagram</span>
          </h2>
          <p className="text-body-large text-muted-foreground max-w-2xl mx-auto font-serif">
            Scopri le novità del <strong>ristorante Da Armando</strong>: piatti del giorno, specialità stagionali della <strong>cucina umbra</strong> e gli eventi speciali sul <strong>Lago Trasimeno</strong>. Seguici su Instagram @daarmandopassignano!
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
                     <Card className="card-elegant p-4 md:p-8 bg-gradient-to-r from-pink-500/10 to-purple-500/10 border-pink-200">
                         <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8">
               {/* Logo e Scritta */}
               <div className="flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-4 lg:space-x-6 w-full lg:w-auto">
                <div className="flex-shrink-0">
                  <div className="bg-gradient-to-br from-pink-500 to-purple-600 p-3 sm:p-4 rounded-full shadow-lg">
                    <Instagram className="text-white" size={40} />
                  </div>
                </div>
                                 <div className="text-center sm:text-left flex-1 min-w-0">
                   <h3 className="text-lg sm:text-xl md:text-3xl font-bold text-primary mb-2 break-words">
                     @daarmandopassignano
                   </h3>
                   <p className="text-xs sm:text-sm md:text-lg text-muted-foreground leading-relaxed">
                     Piatti speciali, ingredienti freschi e la passione per la cucina umbra
                   </p>
                 </div>
              </div>

              {/* Pulsante */}
              <div className="flex-shrink-0 w-full lg:w-auto">
                <Button
                  onClick={() => {
                    window.open("https://www.instagram.com/daarmandopassignano/", "_blank");
                  }}
                  className="bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl w-full lg:w-auto"
                  size="lg"
                >
                  <Instagram className="mr-2 sm:mr-3 h-5 w-5 sm:h-6 sm:w-6" />
                  Seguici su Instagram
                </Button>
              </div>
                         </div>
           </Card>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection; 